/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/customer-group-orders';

export const CustomerGroupOrderApi = {
  findCustomerGroupOrders: async () => {
    const url = `${pathname}/name`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForCreate: async (option: FindOptions) => {
    let url = `${pathname}/find-partner-for-create-customer-group-order`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findPartnerForCreateWithCustomerID: async (id: string) => {
    const url = `${pathname}/find-partner-for-create-customer-group-order/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: FindOptions) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: CreateMultiCustomerGroupOrder) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  sort: async (body: any) => {
    const url = `${pathname}/sort`;

    try {
      const response = await entityService.patch(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string, option: FindOptions) => {
    let url = `${pathname}/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: DeleteMultiCustomerGroupOrderBody) => {
    const url = `${pathname}/delete/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export type CustomerGroupOrder = {
  name: string;
  id?: string;
  ownerID: string;
  owner: any;
  supplierID: string;
  supplier: any;
  customerID: string;
  customer: any;
  order: number;
  orderID: string;
  customerOrder: any;
  status: number;
  createdAt: string;
  updatedAt: string;
  acceptFullOrderCustomerQuantity?: boolean;
  disableUpdateAcceptFullOrderCustomerQuantity?: boolean;
  partnerID?: string;
};

export interface FindCustomerGroupOrdersToBalanceOptions {
  options: {
    type?: number;
    customerName?: string;
    page: number;
    take: number;
  };
  body: {
    ids?: string[];
    entityProductIDs?: string[];
    entityProducts: any;
    startedAt?: string;
    finishedAt?: string;
  };
}

export interface DeleteMultiCustomerGroupOrderBody {
  customerGroupOrderIDs: string[];
  page: number;
  take: number;
}

export interface CreateMultiCustomerGroupOrder {
  entityProductIDs?: string[];
  customerGroupOrders: Array<{
    supplierID: string;
    customerID: string;
  }>;
}

export type PartnerForCreateWithCustomerID = {
  id: string;
  name: string;
  pathName: string;
  supplierID: string;
  customerID: string;
  path: string[];
  customerGroupOrder?: CustomerGroupOrder;
  checkValue?: boolean;
};
